module.exports = __webpack_public_path__ + "media/images/admin/icons/person-0fdcd8c4d6ccfc348a8980b7514975ff.png";